// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"ProfileUploadForm__wrapper__24QTT","submitResult":"ProfileUploadForm__submitResult__7e_q1","actionWrapper":"ProfileUploadForm__actionWrapper__2V8C-","wrapper2faOptions":"ProfileUploadForm__wrapper2faOptions__3I-um"};


//////////////////
// WEBPACK FOOTER
// ./src/components/ProfileUploadForm/ProfileUploadForm.css
// module id = 3056
// module chunks = 0